<template>
  <div>
    <div class="item_list">
      <div class="liveswill"
           v-for="(item,index) in video_newest"
           v-if="index<num"
           :key="'video_newest'+index">
        <p class="item_title">
          <span class="title_name">
            <span>{{item.group.egName}}频道</span>
            <span>{{getTimes(item.vCreateDt)}}</span>
          </span>

        </p>
        <div class="con"
             @click="toDetails(item)">
            <div style="position: relative;width:212px">
              <div v-if="checkUserMember">
                  <get-vip-img v-if="item.vIsvipfree==1"></get-vip-img>
              </div>

              <img class="con_images"
                  :src="item.vPicUrl"
                  alt=""
                  v-if="item.vPicUrl">
              <img class="con_images"
                  :src="item.vViewUrl+'?x-oss-process=video/snapshot,t_5000,f_jpg,w_800,h_600,m_fast'"
                  alt=""
                  v-else>
            </div>
          <div class="con_right">
            <p class="con_title">{{item.vTitle}}</p>
            <div class="con-a-wrap">
              <p class="con_author">{{item.vSpeaker}}</p>
              <div class="public">{{item.vIsPublic=='1'?'公开课':'非公开课'}}</div>
              <div class="view-count">{{item.vViewCount}}人观看</div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <p class="open"
       v-if="video_newest.length>10&&num<11">
      <span @click="openall">展开全部 <span class="icon iconfont">&#xe627;</span></span>

    </p>
    <div class="none"
         v-show="video_newest.length==0">
      <img src="../../assets/images/nonelist.png"
           alt="">
      <p>暂无更多</p>
    </div>

  </div>
</template>
<script>
import '../../assets/style/font1/iconfont.css'

import weui from 'weui.js'
import bus from '../../components/bus/index'
import GetVipImg from '../getvipimg/getVipImg.vue';
import loginService from '../../plugin/extendFn/loginService';
export default {
  components: {
    GetVipImg
  },
  data () {
    return {
      checkUserMember:true,
      ismember: false,
      ra_wxUser: null,
      num: 10,
    }
  },
  props: {
    video_newest: {
      type: Array,
    }
  },
  methods: {
    getUser(){
      let type = this.ra_wxUser && this.ra_wxUser.uMemberType;
      if(type == 1 || type ==2){
        //this.checkUserMember = true;
      }
      console.log(this.ra_wxUser);
    },
    getTimes (value) {
      return new Date(value).Format("yyyy.MM.dd hh:mm");
    },
    openall () {
      this.num = this.video_newest.length;
    },
    cancelMember () {
      this.ismember = false;
    },
    toDetails (item) {
      // vId,item.vIsPublic


      this.$router.push({
        name: "vDetails",
        query: { type: "video", videoId: item.vId },
      });




    },
  },
  computed: {
    routerName () {
      return this.$route.name
    }
  },
  async mounted () {
    this.ra_wxUser= await loginService.getLoginUser();

    this.getUser();
  }
}
</script>
<style scoped lang="scss">
.liveswill {
  border: 1px solid #e6e6e6;
  height: 240px !important;
  border-radius: 5px;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  width: 232px;
  cursor: pointer;
  background: #fff;
  padding: 0 10px;

  float: left;
  margin: 24px 24px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-pack: justify;
  -webkit-box-pack: justify;
  justify-content: flex-start;
  .con {
    margin-top: 6px;
  }
  .item_title {
    padding-top: 6px !important;
  }
  .title_name {
    font-size: 12px;
    color: #666666 !important;
    display: flex;
    justify-content: space-between;
    span:nth-of-type(1){
      width: 110px;
      display: inline-block;
      display: -webkit-box;
      -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
      -webkit-line-clamp: 1; /*限制文本行数*/
      /*white-space: nowrap;      !*超出的空白区域不换行*!*/
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*文本超出显示省略号*/

    }
  }
  .con_images {
    width: 212px !important;
    height: 120px !important;
    border-radius: 5px !important;
  }
  .con_title {
    font-size: 14px !important;
    color: #333;
    width: 210px;
    height: 44px;
    display: -webkit-box;
    -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
    -webkit-line-clamp: 2; /*限制文本行数*/
    /*white-space: nowrap;      !*超出的空白区域不换行*!*/
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*文本超出显示省略号*/
  }

  .con_author {
    font-size: 12px !important;
    font-weight: 300 !important;
    color: #666666 !important;
    min-height: 14px !important;
    //margin-top: 5px !important;
  }
  .last {
    padding: 0px !important;
    box-sizing: border-box !important;
    margin-top: 6px !important;
    height: 20px;
    font-size: 12px;
    color: #666666;
  }
}
.item_list {
  overflow: hidden;
  min-width: 1280px;
  width: 1280px;
  margin: 0 auto;
}
.open {
  color: #000;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;
  span {
    font-size: 12px;
    cursor: pointer;
    color: #ffb441;
  }
  .iconfont {
    font-size: 9px;
    color: #666666;
  }
}
.container_item {
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: 1px solid #e6e6e6;
  background: #ffffff;
  /*width: 6.9rem;*/
  height: 2.6rem;
  margin-bottom: 0.2rem;
  .item_con {
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    padding: 0.2rem 0.2rem;
    box-sizing: border-box;
    position: relative;
    .text_desc {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 1.6rem;
    }
    img {
    }
    .item_title {
      width: 3.47rem;
      font-size: 0.34rem;
      line-height: 0.42rem;
      font-weight: bold;
      display: -webkit-box;
      -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
      -webkit-line-clamp: 2;
      color: #333333;
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*文本超出显示省略号*/
    }
    .item_text {
      color: #333333;
      p {
        font-size: 0.26rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 3.47rem;
        /*line-height: 0.68rem;*/
        /*height: 0.25rem;*/
      }
    }
  }
  .num_type {
    font-size: 0.24rem;
    height: 0.6rem;
    display: flex;
    align-items: center;
    p {
      width: 50%;
      display: flex;
      align-items: center;
      height: 0.28rem;
      color: #666666;
    }
    p:nth-of-type(2) {
      text-align: left;
      padding-left: 0.4rem;
      box-sizing: border-box;
    }
    img {
      margin-right: 0.2rem;
    }
    .see {
      width: 0.4rem;
    }
    .lesson {
      width: 0.4rem;
    }
    p:nth-of-type(1) {
      justify-content: center;

      border-right: 1px solid #e6e6e6;
    }
  }
}
.none {
  width: 100%;
  min-height: 260px;
  /*padding-top: 2.64rem;*/
  box-sizing: border-box;
  text-align: center;
  img {
    width: 100px;
    display: inline-block;
    margin: 100px auto 0px;
    /*width: 100%;*/
  }
  p {
    font-size: 26px;
    color: #999999;
    text-align: center;
  }
}
.member {
  background: rgba(0, 0, 0, 0.5);
  min-width: 100vw;
  min-height: 100vh;
  position: fixed !important;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 9999 !important;
  > div {
    width: 5rem;
    z-index: 10001 !important;
    background: #ffffff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    font-size: 0.16rem;
    margin: 4rem auto;
    height: 3.5rem;
    padding: 0.2rem 0.28rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ul {
      width: 100%;
      li:nth-of-type(1) {
        font-weight: bolder;
        font-size: 0.32rem;
      }
      li:nth-of-type(2) {
        text-indent: 0.56rem;
        font-size: 0.28rem;
        margin-top: 0.2rem;
      }
      li {
        width: 100%;
        font-size: 0.28rem;
      }
    }
    > p {
      width: 100%;
      display: flex;
      justify-content: space-between;
      button {
        width: 2rem;
        height: 0.6rem;
        border: none;
        outline: none;
        background: linear-gradient(#e7e8e9, #babbbb);
        color: #333;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
      }
      a > button {
        color: #ffffff;
        background: linear-gradient(#21afff, #007fff);
      }
    }
  }
}
.leve {
  width: 0.49rem;
  height: 0.49rem;
  position: absolute;
  z-index: 3;
}

.con-a-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 12px;
  font-weight: 300;
  margin-top: 5px;

  .view-count {
    color: #ea3223;
  }

  .public{
    //color: #001cf5;
  }

  .con_author {
    color: #999;
    min-height: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/container/videoList.vue